import Repository from '@/libs/axios'

const merchantSettingsResource = '/admin/settings/merchant'
const termsAndConditionResource = '/admin/terms-and-condition'

const defaultPagination = 10
export default {
  getMerchantSettingsResource() {
    return Repository.get(`${merchantSettingsResource}`)
  },
  updateMerchantSettingsResource(payload) {
    return Repository.put(`${merchantSettingsResource}`, payload)
  },
  fetchTermsAndConditionsVersions(filterQuery, pageNumber = 1, pagination = defaultPagination) {
    return Repository.get(`${termsAndConditionResource}?${filterQuery}&paginate=${pagination}&page=${pageNumber}`)
  },
  onClickDelete(id) {
    return Repository.delete(`${termsAndConditionResource}/${id}`)
  },
  storeTermsAndCondition(payload) {
    return Repository.post(`${termsAndConditionResource}`, payload)
  },
  onClickEditTermsAndCondition(id) {
    return Repository.get(`${termsAndConditionResource}/${id}`)
  },
  updateTermsAndCondition(payload) {
    return Repository.put(`${termsAndConditionResource}/update`, payload)
  },
  storeTermsAndConditionPdf(payload) {
    return Repository.post(`${termsAndConditionResource}/store-pdf`, payload)
  },
  fetchDataForTermsAndConditionsNoPagination(filterQuery) {
    return Repository.get(`${termsAndConditionResource}?${filterQuery}&noPagination=true`)
  },
  updateTermsAndConditionStatus(payload) {
    return Repository.put(`${termsAndConditionResource}/status-update`, payload)
  },
}
